import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {baseFill, baseStroke} from '../shared/partVariants';

interface RearBoardProps {
  readonly mode?: PartMode;
  readonly onClick?: () => void;
}

export function RearBoard(props: RearBoardProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Rear Board"
      width={172}
      height={434}
      viewBox="0 0 172 434"
      position={{top: 34, right: 162}}
    >
      <path
        d="M48 365C48 413 1 419 1 419C5 419 6 421 11 433C33.1643 432.939 64.0853 432.687 95.7888 432.144L96 432C102.4 428 120 414 133 395C138.001 388 171 320 171 241V217V193C171 114 138.001 46 133 39C120 20 102.4 6 96 2L95.7462 1.85477C64.0576 1.3127 33.1544 1.06069 11 1C6 13 5 15 1 15C1 15 48 21 48 69V217V365Z"
        fill="currentColor"
        className={cn(baseFill())}
      ></path>
      <path
        d="M48 365C48 413 1 419 1 419C5 419 6 421 11 433C33.1643 432.939 64.0853 432.687 95.7888 432.144L96 432C102.4 428 120 414 133 395C138.001 388 171 320 171 241V217V193C171 114 138.001 46 133 39C120 20 102.4 6 96 2L95.7462 1.85477C64.0576 1.3127 33.1544 1.06069 11 1C6 13 5 15 1 15C1 15 48 21 48 69V217V365Z"
        stroke="currentColor"
        strokeWidth="2"
        className={baseStroke()}
      />
      <circle cx="96" cy="62" r="15" fill="currentColor" className={cn(baseFill())}></circle>
      <circle
        cx="96"
        cy="62"
        r="15"
        stroke="currentColor"
        strokeWidth="2"
        className={baseStroke()}
      />
      <circle cx="96" cy="62" r="11" stroke="currentColor" className={baseStroke()} />
      <circle cx="96" cy="62" r="2" stroke="currentColor" className={baseStroke()} />
      <path
        d="M139 217C139 211.276 137.397 205.927 134.616 201.376C137.264 200.219 139 197.576 139 194.5C139 190.358 135.642 187 131.5 187C128.424 187 125.874 188.792 124.716 191.441C120.146 188.625 114.763 187 109 187C103.276 187 97.9269 188.603 93.3763 191.384C92.219 188.736 89.5755 187 86.5 187C82.3579 187 79 190.358 79 194.5C79 197.576 80.7387 200.214 83.3875 201.371C80.6041 205.923 79 211.274 79 217C79 222.742 80.7017 228.064 83.5 232.624C80.8511 233.781 79 236.424 79 239.5C79 243.642 82.3579 247 86.5 247C89.4686 247 92.1324 245.1 93.3479 242.598C97.9046 245.39 103.264 247 109 247C114.777 247 120.085 245.417 124.663 242.588C125.84 245.19 128.459 247 131.5 247C135.642 247 139 243.642 139 239.5C139 236.478 137.213 233.873 134.637 232.686C137.467 228.108 139 222.777 139 217Z"
        fill="currentColor"
        className={cn(baseFill())}
      ></path>
      <circle
        cx="2"
        cy="2"
        r="2"
        transform="matrix(1 0 0 -1 130 196)"
        stroke="currentColor"
        className={baseStroke()}
      />
      <circle
        cx="2"
        cy="2"
        r="2"
        transform="matrix(1 0 0 -1 130 242)"
        stroke="currentColor"
        className={baseStroke()}
      />
      <circle
        cx="2"
        cy="2"
        r="2"
        transform="matrix(1 0 0 -1 84 196)"
        stroke="currentColor"
        className={baseStroke()}
      />
      <circle
        cx="2"
        cy="2"
        r="2"
        transform="matrix(1 0 0 -1 84 242)"
        stroke="currentColor"
        className={baseStroke()}
      />
      <path
        d="M139 217C139 211.276 137.397 205.927 134.616 201.376C137.264 200.219 139 197.576 139 194.5C139 190.358 135.642 187 131.5 187C128.424 187 125.874 188.792 124.716 191.441C120.146 188.625 114.763 187 109 187C103.276 187 97.9269 188.603 93.3763 191.384C92.219 188.736 89.5755 187 86.5 187C82.3579 187 79 190.358 79 194.5C79 197.576 80.7387 200.214 83.3875 201.371C80.6041 205.923 79 211.274 79 217C79 222.742 80.7017 228.064 83.5 232.624C80.8511 233.781 79 236.424 79 239.5C79 243.642 82.3579 247 86.5 247C89.4686 247 92.1324 245.1 93.3479 242.598C97.9046 245.39 103.264 247 109 247C114.777 247 120.085 245.417 124.663 242.588C125.84 245.19 128.459 247 131.5 247C135.642 247 139 243.642 139 239.5C139 236.478 137.213 233.873 134.637 232.686C137.467 228.108 139 222.777 139 217Z"
        stroke="currentColor"
        strokeWidth="2"
        className={baseStroke()}
      />
      <circle cx="109" cy="217" r="25" stroke="currentColor" className={baseStroke()} />
      <circle cx="109" cy="217" r="6" stroke="currentColor" className={baseStroke()} />
      <circle cx="96" cy="372" r="15" fill="currentColor" className={cn(baseFill())}></circle>
      <circle
        cx="96"
        cy="372"
        r="15"
        stroke="currentColor"
        strokeWidth="2"
        className={baseStroke()}
      />
      <circle cx="96" cy="372" r="11" stroke="currentColor" className={baseStroke()} />
      <circle cx="96" cy="372" r="2" stroke="currentColor" className={baseStroke()} />
    </PartSvg>
  );
}
